import styled from "styled-components";

const ImageContainer = styled.div`
  cursor: pointer;
  border-radius: 5px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: ${(props) =>
      props.selected ? "#fe6030" : "transparent"};
    transform: rotate(-3deg);
    border-radius: 5px;
  }
`;

const Image = styled.img`
  position: relative;
  background-color: #fffbec;
  padding: 15px 0px;
  border-radius: 5px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Emblem = ({ src, chosenEmblem, onClick, selected }) => {
  return (
    <ImageContainer onClick={onClick} selected={selected}>
      <Image src={src} chosenEmblem={chosenEmblem} alt="" />
    </ImageContainer>
  );
};
